export default {
    animals: [],
    observations: [],
    filters: {
        parents: [],
    },
}
